import VisualizationCard from "./VisualizationCard.jsx";
import "../../styles/visualization/visualizationGrid.css";
import StudioVisualizationCard from "../studio/StudioVisualizationCard.jsx";

const VisualizationGrid = ({
  records = [],
  isLoading,
  Card,
  onDelete,
}) => {
  if (records.length === 0) {
    return (
      <div className="viz-empty">
        <p>No visualizations found.</p>
      </div>
    );
  }

  return (
    <section className="viz-grid-wrapper">
      <div className="viz-grid">
        {records.map((item) => (
          <Card
            key={item.publicationId || item.animationId}
            data={item}
            onDelete={onDelete}
          />
        ))}
      </div>

      {isLoading && (
        <div className="viz-loading">Loading more visualizations...</div>
      )}
    </section>
  );
};

export default VisualizationGrid;
